// extracted by mini-css-extract-plugin
export default {"container":"chip__container___3kTwd"};